<form [formGroup]="form">
  <mat-form-field style="width: 100%">
    <mat-label>
      <ng-container *ngIf="selected$ | async as tic; else showDefault">
        ({{ tic.ticId }}) - {{ tic.description }}
      </ng-container>

      <ng-template #showDefault> Tax Identification Code </ng-template>
    </mat-label>
    <input matInput type="phone" tcOnlyNumber formControlName="ticId" />
    <button
      matSuffix
      mat-icon-button
      data-cy="searchButton"
      aria-label="Lookup tax code"
      (click)="openTaxCodeSearchDialog()"
      tcColor="primary"
    >
      <mat-icon>search</mat-icon>
    </button>
    <mat-error>Invalid Tax Code</mat-error>
  </mat-form-field>
</form>
